// Generated from api/openapi/admin.yaml by make docs. Do not edit.
import { z } from "zod";

export const platformAdminStatusSchema = z.enum(["pending", "active", "inactive", "expired"]);

export const platformAdminSchema = z.object({
  "id": z.string().uuid(),
  "tenant_id": z.string().uuid().optional(),
  "email": z.string(),
  "name": z.string(),
  "phone": z.string().optional(),
  "role": z.enum(["platform_admin", "platform_operator", "tenant_admin", "tenant_operator", "tenant_readonly", "compliance_reader"]),
  "status": platformAdminStatusSchema,
  "kind": z.enum(["human", "automation_account"]),
  "last_login_at": z.string().datetime({ offset: true }).optional(),
  "deactivated_at": z.string().datetime({ offset: true }).optional(),
  "created_at": z.string().datetime({ offset: true }),
  "updated_at": z.string().datetime({ offset: true })
});

export const platformAdminsListResponseSchema = z.object({
  "items": z.array(platformAdminSchema),
  "next_cursor": z.string().uuid().optional()
});

export const inviteAdminResponseSchema = z.object({
  "admin_user": platformAdminSchema,
  "enrollment_token": z.string().optional(),
  "warnings": z.array(z.string()).optional()
});
